@if (signedIn()) {
  <app-header [showMemu]="showMemu()"></app-header>
}

<div [class.margin-top-menu]="signedIn()">
  <ng-content></ng-content>
</div>

@if (signedIn()) {
  <app-footer></app-footer>
}
